exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Places__table-1_ {\n  font-size: 0.85rem\n}\n.Places__table-1_ caption {\n    font-weight: bold;\n  }\n.Places__table-1_ th {\n    text-align: left;\n    font-weight: normal;\n    text-decoration: underline;\n  }\n", ""]);

// exports
exports.locals = {
	"table": "Places__table-1_"
};